<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 2C5.55228 2 6 2.44772 6 3V4H7C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H6V7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7V6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H4V3C4 2.44772 4.44772 2 5 2ZM13 2C13.4304 2 13.8125 2.27541 13.9487 2.68373L16.0838 9.0882L21.3512 11.0637C21.7414 11.2101 22 11.5832 22 12C22 12.4168 21.7414 12.7899 21.3512 12.9363L16.0838 14.9118L13.9487 21.3163C13.8125 21.7246 13.4304 22 13 22C12.5696 22 12.1875 21.7246 12.0513 21.3163L9.9162 14.9118L4.64884 12.9363C4.25856 12.7899 4 12.4168 4 12C4 11.5832 4.25856 11.2101 4.64884 11.0637L9.9162 9.0882L12.0513 2.68373C12.1875 2.27541 12.5696 2 13 2ZM13 6.16186L11.6627 10.1733C11.5672 10.4595 11.3477 10.6874 11.0652 10.7933L7.84771 12L11.0652 13.2067C11.3477 13.3126 11.5672 13.5405 11.6627 13.8267L13 17.8381L14.3373 13.8267C14.4328 13.5405 14.6523 13.3126 14.9348 13.2067L18.1523 12L14.9348 10.7933C14.6523 10.6874 14.4328 10.4595 14.3373 10.1733L13 6.16186ZM6 16C6.55228 16 7 16.4477 7 17V18H8C8.55228 18 9 18.4477 9 19C9 19.5523 8.55228 20 8 20H7V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H5V17C5 16.4477 5.44772 16 6 16Z"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconSparkles",
  props: ["height", "width"],
}
</script>
